import React from 'react';
import { useTheme } from '../ui/theme';
import Icon from '../ui/Icon';
import styles from './Topbar.module.css';

/**
 * Topbar — 56px-tall bar above the page content.
 * All top-level pages render their own <PageHeader>, so the Topbar
 * intentionally shows no route title — it is purely the theme toggle.
 */
export default function Topbar() {
  const { theme, toggle } = useTheme();

  return (
    <header className={styles.topbar}>
      <div className={styles.titleWrap} />

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.iconButton}
          onClick={toggle}
          aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          title={theme === 'dark' ? 'Switch to light' : 'Switch to dark'}
        >
          <Icon name={theme === 'dark' ? 'fa-sun' : 'fa-moon'} size="md" />
        </button>
      </div>
    </header>
  );
}
